import { defineMessages } from 'react-intl'

const messages = defineMessages({
  additionalInformation: {
    id: 'global.additional-information',
  },
  bookingInformation: {
    id: 'global.booking-information',
  },
  bookedBy: {
    id: 'global.booked-by',
  },
  bookingDate: {
    id: 'global.booking-date',
  },
  checkIn: {
    id: 'search.checkin',
  },
  checkOut: {
    id: 'search.checkout',
  },
  stay: {
    id: 'global.stay',
  },
  nightsCount: {
    id: 'global.nights',
  },
  guests: {
    id: 'global.guests',
  },
  modifyDatesAndPaxes: {
    id: 'global.modify-dates-paxes',
  },
  modifyDates: {
    id: 'global.modify-dates-multiroom',
  },
  room: {
    id: 'global.room',
  },
  holder: {
    id: 'global.holder',
  },
  voucherNumber: {
    id: 'voucher.number',
  },
  pending: {
    id: 'global.pending',
  },
  unsolved: {
    id: 'global.unsolved',
  },
  bookingCancelled: {
    id: 'global.voucher-booking-cancelled',
  },
  bookingNotPaid: {
    id: 'voucher.booking-not-paid',
  },
  creditCardNeeded: {
    id: 'voucher.credit-card-needed',
  },
  previousAttempt: {
    id: 'voucher.previous-attempt',
  },
  bookingStatusMessage: {
    id: 'global.booking-status',
  },
  cancelled: {
    id: 'global.cancelled',
  },
  refundStaywallet: {
    id: 'global.refund-staywallet',
  },
  refundCreditCard: {
    id: 'global.refund-credit-card',
  },
  cancelErrorTitle: {
    id: 'voucher.cancel-error-confirm',
  },
  cancelErrorDescription: {
    id: 'voucher.cancellation-error',
  },
})

export default messages
